import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getReportedProduct = (
    token: string,
    backend: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}reportedproducts/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*'
            },
        }
    );
};

export default getReportedProduct;
